export default __webpack_public_path__ + "static/media/ministry.cac9f18d.png";